// Import model
import { StartLeadSendCustomEmailRequest } from '../models/StartLeadSendCustomEmailRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartLeadSendCustomEmailRequest - handles JSON serialization and deserialization with type validation
 */
export class StartLeadSendCustomEmailRequestSerializer {
  /**
   * Deserializes a JSON string into a StartLeadSendCustomEmailRequest instance
   */
  static deserialize(json: string): StartLeadSendCustomEmailRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartLeadSendCustomEmailRequest instance
   */
  static fromObject(obj: any): StartLeadSendCustomEmailRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartLeadSendCustomEmailRequest');
    }


    const instance: StartLeadSendCustomEmailRequest = {
      description: obj['Description'] as string | undefined,
      unlayerTemplateId: obj['UnlayerTemplateId'] as string | undefined,
      message: obj['Message'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartLeadSendCustomEmailRequest instances
   */
  static deserializeArray(json: string): StartLeadSendCustomEmailRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartLeadSendCustomEmailRequest instance to a JSON string
   */
  static serialize(instance: StartLeadSendCustomEmailRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartLeadSendCustomEmailRequest instance to a plain object
   */
  static toObject(instance: StartLeadSendCustomEmailRequest): any {
    return {
      'Description': instance.description,
      'UnlayerTemplateId': instance.unlayerTemplateId,
      'Message': instance.message,
    };
  }

  /**
   * Serializes an array of StartLeadSendCustomEmailRequest instances to a JSON string
   */
  static serializeArray(instances: StartLeadSendCustomEmailRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
